/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useId, useState } from 'react'
import Highcharts from 'highcharts'
import HC_data from 'highcharts/modules/data'
import { LineChart as LineChartType } from '../../types/StatTypes'
import ChartSkeleton from '../skeleton/ChartSkeleton'
import BaseChart from './BaseChart'
interface ILineChartProps {
  maxY?: number
  format?: string
  chartData: LineChartType
  textColor: string
  rangeDescription: string
  height?: number
  showLegend?: boolean
  tickInterval?: number
  formatter?: ((this: any) => string) | undefined
}

const LineChart = (props: ILineChartProps) => {
  const { chartData, textColor, rangeDescription, height, maxY, formatter, format = '{value}', showLegend = true, tickInterval = 24 * 3600 * 1000 } = props
  const [isLoading, setIsLoading] = useState(true)
  const chartId = useId()

  useEffect(() => {
    if (chartData) {
      setIsLoading(true)
      const timer = setTimeout(() => setIsLoading(false), 400)
      return () => clearTimeout(timer)
    }
  }, [chartData])

  useEffect(() => {
    if (typeof HC_data === 'function') {
      HC_data(Highcharts)
    }
  }, [])

  const options: any = {
    chart: {
      type: 'line',
      height: height || 300,
      style: {
        fontFamily: 'inherit',
        color: textColor,
      },
      backgroundColor: 'transparent',
    },
    title: {
      text: null,
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        day: '%b %e',
      },
      accessibility: {
        rangeDescription: rangeDescription,
      },
      tickInterval: tickInterval,
      labels: {
        style: {
          color: textColor,
        },
      },
    },
    yAxis: {
      title: '',
      labels: {
        style: {
          color: textColor,
        },
        format: format,
      },
        max: maxY,
      lineColor: textColor,
    },
    legend: showLegend
      ? {
          layout: 'horizontal',
          align: 'left',
          verticalAlign: 'top',
          itemStyle: {
            color: textColor,
          },
          itemHoverStyle: {
            color: textColor,
          },
        }
      : {
          enabled: false,
        },
    tooltip: {
      shared: true,
      crosshairs: true,
      formatter: formatter,
    },
    plotOptions: {
      series: {
        cursor: 'pointer',
        className: 'popup-on-click',
        marker: {
          lineWidth: 1,
        },
      },
    },
    series: chartData.series,
    credits: {
      enabled: false,
    },
  }

  return <>{isLoading ? <ChartSkeleton fullWidth={true} /> : <BaseChart options={options} id={chartId} />}</>
}

export default LineChart
